/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

module.exports = ('toastService', ['$resource', 'ngToast', function ($resource, ngToast) {
        var toast = {};
        toast.createToast = function (className, msg) {
            ngToast.create({
                className: className,
                content: msg,
                dismissButton: true,
                dismissOnTimeout: true,
                timeout: 10000
            });
        };

        toast.createSuccessToast = function (msg) {
            this.createToast('alert alert-success', msg);
        };

        toast.createInfoToast = function (msg) {
            this.createToast('alert alert-info', msg);
        };

        toast.createWarningToast= function (msg) {
            this.createToast('alert alert-warning', msg);
        };

        toast.createErrorToast=function (msg) {
            this.createToast('alert alert-danger', msg);
        };

        return toast;
    }]);





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/services/toastService.js
// module id = 318
// module chunks = 0